import React from 'react';
import PropTypes from 'prop-types';
import Input from '@ferris/react/components/forms/Input';
import classNames from 'classnames';

const noop = () => {};
const GLANCE_MASKED = { glance_masked: 'true' };

function isPhoneNumberValid(phoneNumber) {
    return /^(?! {2})[0-9\-() ]*$/.test(phoneNumber);
}

function getPhoneObject(phoneNumber, phoneCode) {
    return {
        raw: phoneNumber.replace(/[- )(]/g, ''),
        formatted: phoneNumber,
        phoneCode,
        isValid: isPhoneNumberValid(phoneNumber)
    };
}

export const PhoneField = (props) => {
    const {
        phoneCode,
        onChange,
        onBlur,
        onFocus,
        id,
        labels,
        showCountrySelect,
        phoneNumber,
        errorMsg
    } = props;

    const handleChange = (e) => {
        onChange(e, getPhoneObject(e.target.value, phoneCode));
    };

    const handleFocus = (e) => {
        onFocus(e, getPhoneObject(e.target.value, phoneCode));
    };

    const handleBlur = (e) => {
        onBlur(e, getPhoneObject(e.target.value, phoneCode));
    };

    const inputClassName = classNames({
        [`react-input-tel__country-code-${phoneCode.length}`]: true,
        'react-input-tel__phone-field': true,
        'show-dropdown': showCountrySelect,
        'not-empty':
            phoneNumber
    });


    return (
        <div
            role="presentation"
            className="input-group-wrapper"
            {...GLANCE_MASKED}
        >
            <Input
                formControlProps={{ id }}
                classes={inputClassName}
                fullWidth
                label={labels.phoneNumber}
                type="tel"
                isControlled
                floatLabel
                data-wdio="input-tel__phone-field__input"
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                invalid={errorMsg && errorMsg.length}
                validationMessage={errorMsg || ''}
                value={phoneNumber}
            />
        </div>
    );
};

PhoneField.propTypes = {
    id: PropTypes.string.isRequired,
    showCountrySelect: PropTypes.bool.isRequired,
    labels: PropTypes.shape({
        phoneNumber: PropTypes.string.isRequired
    }),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    phoneCode: PropTypes.string,
    phoneNumber: PropTypes.string,
    errorMsg: PropTypes.string
};

PhoneField.defaultProps = {
    labels: {},
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    phoneCode: '1',
    phoneNumber: '',
    errorMsg: ''
};

export default PhoneField;
